import { FAQ_GROUPS } from '@/content/site-content';
import { ChevronDownIcon } from '@/components/ui/Icons';

/**
 * Two columns of questions, one per audience.
 *
 * Built on `<details>`, so it opens and closes without JavaScript, is
 * keyboard-operable for free, and stays findable by in-page search.
 */
export function FaqSection() {
  return (
    <section id="faq" className="scroll-mt-28 bg-canvas py-16 lg:py-20">
      <div className="container-page">
        <h2 className="text-center text-3xl font-extrabold sm:text-4xl">
          Frequently Asked <span className="text-brand-600">Questions</span>
        </h2>
        <p className="mt-4 text-center text-sm text-ink-soft sm:text-base">
          Answers for both parents and young people getting started.
        </p>

        <div className="mt-12 grid gap-x-12 gap-y-10 lg:grid-cols-2">
          {FAQ_GROUPS.map((group) => (
            <div key={group.heading}>
              <h3 className="border-b border-line pb-3 text-base font-bold text-ink">
                {group.heading}
              </h3>

              <div className="divide-y divide-line">
                {group.items.map((item) => (
                  <details key={item.question} className="group py-4">
                    <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-sm font-semibold text-ink marker:content-none">
                      {item.question}
                      <ChevronDownIcon className="size-4 shrink-0 text-ink-soft transition duration-200 group-open:rotate-180" />
                    </summary>
                    <p className="mt-3 text-sm leading-relaxed text-ink-soft">{item.answer}</p>
                  </details>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
